import { Brand } from './brand';

const cie: Brand = {
  logo: 'cie',
  showSubmissionDatePicker: true,
  showConsortiaManagementLink: false,
  showSelectSeriesDateDisclaimer: true,
  allowExaminedComponents: true,
  showRmFileSubmissionLink: true,
  showMalpracticeReportsLink: true,
};
export default cie;
